import { Container, ContentHeader, Page } from 'components'
import { CopyForm } from './components/Copy/components'

const DataProcessesMain = () => {
  return (
    <Page title="Copiar Processos">
      <Container
        maxWidth={false}
        spacingXl={20}
        spacingLg={15}
        spacingMd={10}
        spacingSm={5}
        spacingXs={5}
      >
        <ContentHeader
          menu="Processos"
          title="Copiar"
          subtitle="Copiar processos"
        />
        <CopyForm />
      </Container>
    </Page>
  )
}

export default DataProcessesMain
